import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { post } from "../../services/api";
import ENDPOINTS from "../../utils/constants/endpoints";
import CryptoJS from "crypto-js";  
import { clearStoredSession, readStoredSession } from '../../utils/session';
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ identifier, password }, { rejectWithValue }) => {
    try {
      // Hash password before sending
      const hashedPassword = CryptoJS.SHA1(password).toString(CryptoJS.enc.Hex);

      const response = await post(ENDPOINTS.AUTH.LOGIN, {
        platform: "Web",
        username: identifier,
        password: hashedPassword,   // 👈 hashed
        token_id: "9914cc4a99a5aaba5435076915a7167a99a952d8",
        captch_code: "BhNXE7",
        agent: "Chrome-131.0-Win32",
      });

      if (response?.status !== "success") {
        return rejectWithValue(
          response?.["success message"] || "Login failed"
        );
      }

      const usersMst = response?.data?.usersMst || {};
      const token = usersMst?.token || null;
      const role_id = usersMst?.role_id || null;
      const user = usersMst;
      if (!token || !role_id) return rejectWithValue('The login response is missing session details. Please sign in again.');

      if (token) localStorage.setItem("token", token);
      sessionStorage.setItem("token", token);
      if (role_id) localStorage.setItem("role_id", role_id);
    
      localStorage.setItem("user", JSON.stringify(user));

      return { token, role_id, user };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Login Failed");
    }
  }
);

const initialState = {
  ...readStoredSession(),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      state.role_id = null;
      state.user = null;
      clearStoredSession();

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.role_id = action.payload.role_id;
        state.user = action.payload.user;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
